import chickens from '../../images/chickens.png'

export const agroNews = [{
    id: 1,
    image: chickens,
    title: 'All of Confidence people',
    subtitle: 'Agro Ease',
    body: 'Nneoma our mama of the house and Emeka troublemaker and Ebuka oga problem solver'
  },
    {
      id: 2,
    image: chickens,
    title: 'All of Confidence people',
    subtitle: 'Agro Ease',
    body: 'Nneoma our mama of the house and Emeka troublemaker and Ebuka oga problem solver'
  },
    {
      id: 3,
    image: chickens,
    title: 'All of Confidence people',
    subtitle: 'Agro Ease',
    body: 'Nneoma our mama of the house and Emeka troublemaker and Ebuka oga problem solver'
  },
    {
      id: 4,
    image: chickens,
    title: 'All of Confidence people',
    subtitle: 'Agro Ease',
    body: 'Nneoma our mama of the house and Emeka troublemaker and Ebuka oga problem solver'
  },
    {
      id: 5,
    image: chickens,
    title: 'All of Confidence people',
    subtitle: 'Agro Ease',
    body: 'Nneoma our mama of the house and Emeka troublemaker and Ebuka oga problem solver'
  },
    {
      id: 6,
    image: chickens,
    title: 'All of Confidence people',
    subtitle: 'Agro Ease',
    body: 'Nneoma our mama of the house and Emeka troublemaker and Ebuka oga problem solver'
  },
    {
      id: 7,
    image: chickens,
    title: 'All of Confidence people',
    subtitle: 'Agro Ease',
    body: 'Nneoma our mama of the house and Emeka troublemaker and Ebuka oga problem solver'
  },
    {
      id: 8,
    image: chickens,
    title: 'All of Confidence people',
    subtitle: 'Agro Ease',
    body: 'Nneoma our mama of the house and Emeka troublemaker and Ebuka oga problem solver'
  },
    {
      id: 9,
    image: chickens,
    title: 'All of Confidence people',
    subtitle: 'Agro Ease',
    body: 'Nneoma our mama of the house and Emeka troublemaker and Ebuka oga problem solver'
  },
    {
      id: 10,
    image: chickens,
    title: 'All of Confidence people',
    subtitle: 'Agro Ease',
    body: 'Nneoma our mama of the house and Emeka troublemaker and Ebuka oga problem solver'
  },
    {
      id: 11,
    image: chickens,
    title: 'All of Confidence people',
    subtitle: 'Agro Ease',
    body: 'Nneoma our mama of the house and Emeka troublemaker and Ebuka oga problem solver'
  },
    {
      id: 12,
    image: chickens,
    title: 'All of Confidence people',
    subtitle: 'Agro Ease',
    body: 'Nneoma our mama of the house and Emeka troublemaker and Ebuka oga problem solver'
  }
]